export default "__VITE_ASSET__BD_VM9N6__"